module.exports = __webpack_public_path__ + "img/check-on.7f28655c.svg";